module.exports = __webpack_public_path__ + "static/media/redHeart.e87899ae.svg";